import { useCallback, useState } from 'react'
import { GlobalSearchDialog } from './GlobalSearchDialog'
import { useCommandPalette, type PaletteSource } from './useCommandPalette'

/**
 * The one command overlay. ⌘K / the sidebar's Quick actions pill and `/` /
 * the header field / the sidebar's search button all open the same
 * GlobalSearchDialog; the mode only chooses whether it opens on the Actions
 * category or on All. Mounted once in the authenticated layout, inside
 * CommandPaletteProvider.
 *
 * Closing keeps the dialog mounted, inert, until its exit finishes; a new open
 * during the exit replaces it with a fresh dialog.
 */
export function CommandPalette() {
  const { mode, searchSource } = useCommandPalette()
  // The open that the dialog on screen belongs to. It outlives `mode`.
  const [shown, setShown] = useState<PaletteSource | null>(null)
  if (mode && searchSource && searchSource !== shown) setShown(searchSource)
  // Only the dialog still on screen may unmount itself.
  const exited = useCallback((source: PaletteSource) => setShown(current => (current === source ? null : current)), [])
  if (!shown) return null
  return <GlobalSearchDialog key={shown.id} source={shown} open={mode !== null && searchSource === shown} onExited={exited} />
}
